<template>
    <a-modal v-model="visible" title="复核打分表" width="40%" centered :maskClosable="false" :keyboard="false" :footer="null" class="diyModelCls">
        <a-spin :spinning="loading">
            <a-tabs :activeKey="activeKey" @change="changeTab">
                <a-tab-pane key="1" tab="规划研究类">
                    <div class="scoreTable">
                        <table>
                            <tr>
                                <td colspan="4">规划研究类</td>
                            </tr>
                            <tr>
                                <td colspan="4" align="left">
                                    主要咨询服务范围：规划咨询（含总体规划、专项规划、区域规划、行业规划等各类规划），工程咨询单位自行开展或接受政府有关部门（机构）委托开展的智库型政策研究专题研究，以及新理论新方法等。
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" width="35%">评价指标</td>
                                <td colspan="3">评定得分</td>
                            </tr>
                            <tr rowspan="2">
                                <td>合格</td>
                                <td>良好</td>
                                <td>优秀</td>
                            </tr>
                            <tr>
                                <td>研究难度（15分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="yjndcheck[0].value" placeholder="9.0≤得分<12.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yjndcheck[1].value" placeholder="12.0≤得分<13.5" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yjndcheck[2].value" placeholder="13.5≤得分≤15.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>研究深度（20分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="yjsdcheck[0].value" placeholder="12.0≤得分<16.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yjsdcheck[1].value" placeholder="16.0≤得分<18.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yjsdcheck[2].value" placeholder="18.0≤得分≤20.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>创新程度（20分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="cxcdcheck[0].value" placeholder="12.0≤得分<16.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="cxcdcheck[1].value" placeholder="16.0≤得分<18.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="cxcdcheck[2].value" placeholder="18.0≤得分≤20.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>方法先进性（15分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="ffxjx_ghyjcheck[0].value" placeholder="9.0≤得分<12.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="ffxjx_ghyjcheck[1].value" placeholder="12.0≤得分<13.5" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="ffxjx_ghyjcheck[2].value" placeholder="13.5≤得分≤15.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>可操作性（15分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="kczxcheck[0].value" placeholder="9.0≤得分<12.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="kczxcheck[1].value" placeholder="12.0≤得分<13.5" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="kczxcheck[2].value" placeholder="13.5≤得分≤15.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>应用价值（15分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="yyjz_ghyjcheck[0].value" placeholder="9.0≤得分<12.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yyjz_ghyjcheck[1].value" placeholder="12.0≤得分<13.5" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yyjz_ghyjcheck[2].value" placeholder="13.5≤得分≤15.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>总分</td>
                                <td colspan="3">{{ zf_ghyj }}</td>
                            </tr>
                            <tr>
                                <td colspan="4" align="left">
                                    填表说明：<br />
                                    1.
                                    为方便对工程咨询成果水平进行评价，参考《全国优秀工程咨询成果奖评奖办法》等文件，将有关工程咨询成果划分为规划研究、项目咨询评估两类。<br />2.
                                    分项评价指标得分在对应等次中勾选，得分应精确到小数点后1位。<br />3.
                                    推荐一等、二等、三等咨询水平成果总分分别不应少于90分、80分、70分。
                                </td>
                            </tr>
                        </table>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="项目咨询评估类">
                    <div class="scoreTable">
                        <table>
                            <tr>
                                <td colspan="4">项目咨询评估类</td>
                            </tr>
                            <tr>
                                <td colspan="4" align="left">
                                    主要咨询服务范围：项目咨询（含项目投资机会研究、投融资策划，项目建议书、项目可行性研究报告、项目申请报告、资金申请报告、项目实施方案、项目策划书的编制，
                                    PPP项目咨询等），评估咨询（各级政府及有关部门委托的对规划、项目建议书、可行性研究报告、项目申请报告、资金申请报告、PPP项目实施方案、初步设计的评估，规划和项目中期评价、后评价，项目概预决算审查，及其他履行投资管理职能所需的专业技术服务），全过程工程咨询等。
                                </td>
                            </tr>
                            <tr>
                                <td width="35%" rowspan="2">评价指标</td>
                                <td colspan="3">评定得分</td>
                            </tr>
                            <tr rowspan="2">
                                <td>合格</td>
                                <td>良好</td>
                                <td>优秀</td>
                            </tr>
                            <tr>
                                <td>项目复杂难易程度(15分)</td>
                                <td>
                                    <a-input-number :precision="1" v-model="xmfznycdcheck[0].value" placeholder="9.0≤得分<12.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="xmfznycdcheck[1].value" placeholder="12.0≤得分<13.5" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="xmfznycdcheck[2].value" placeholder="13.5≤得分≤15.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>论证完整性（20分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="lzwzxcheck[0].value" placeholder="12.0≤得分<16.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="lzwzxcheck[1].value" placeholder="16.0≤得分<18.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="lzwzxcheck[2].value" placeholder="18.0≤得分≤20.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>论证严谨性（20分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="lzyjxcheck[0].value" placeholder="12.0≤得分<16.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="lzyjxcheck[1].value" placeholder="16.0≤得分<18.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="lzyjxcheck[2].value" placeholder="18.0≤得分≤20.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>方法先进性（15分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="ffxjx_xmzxpgcheck[0].value" placeholder="9.0≤得分<12.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="ffxjx_xmzxpgcheck[1].value" placeholder="12.0≤得分<13.5" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="ffxjx_xmzxpgcheck[2].value" placeholder="13.5≤得分≤15.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>咨询或评估贡献(20分)</td>
                                <td>
                                    <a-input-number :precision="1" v-model="zxhpggxcheck[0].value" placeholder="12.0≤得分<16.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="zxhpggxcheck[1].value" placeholder="16.0≤得分<18.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="zxhpggxcheck[2].value" placeholder="18.0≤得分≤20.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>应用价值（10分）</td>
                                <td>
                                    <a-input-number :precision="1" v-model="yyjz_xmzxpgcheck[0].value" placeholder="6.0≤得分<8.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yyjz_xmzxpgcheck[1].value" placeholder="8.0≤得分<9.0" disabled></a-input-number>
                                </td>
                                <td>
                                    <a-input-number :precision="1" v-model="yyjz_xmzxpgcheck[2].value" placeholder="9.0≤得分≤10.0" disabled></a-input-number>
                                </td>
                            </tr>
                            <tr>
                                <td>总分</td>
                                <td colspan="3">{{ zf_xmzxpg }}</td>
                            </tr>
                            <tr>
                                <td colspan="4" align="left">
                                    填表说明：<br />
                                    1.
                                    为方便对工程咨询成果水平进行评价，参考《全国优秀工程咨询成果奖评奖办法》等文件，将有关工程咨询成果划分为规划研究、项目咨询评估两类。<br />
                                    2. 分项评价指标得分在对应等次中勾选，得分应精确到小数点后1位。<br />3.
                                    推荐一等、二等、三等咨询水平成果总分分别不应少于90分、80分、70分。
                                </td>
                            </tr>
                        </table>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </a-spin>
    </a-modal>
</template>

<script>
export default {
    name: "FhdfmxForm",
    props: ["showEdit", "dataId", "zjdfblx"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            activeKey: "1",
            // 编辑数据
            yjndcheck: [
                { key: "yjnd1", value: null },
                { key: "yjnd2", value: null },
                { key: "yjnd3", value: null }
            ],
            yjsdcheck: [
                { key: "yjsd1", value: null },
                { key: "yjsd2", value: null },
                { key: "yjsd3", value: null }
            ],
            cxcdcheck: [
                { key: "cxcd1", value: null },
                { key: "cxcd2", value: null },
                { key: "cxcd3", value: null }
            ],
            ffxjx_ghyjcheck: [
                { key: "ffxjx_ghyj1", value: null },
                { key: "ffxjx_ghyj2", value: null },
                { key: "ffxjx_ghyj3", value: null }
            ],
            kczxcheck: [
                { key: "kczx1", value: null },
                { key: "kczx2", value: null },
                { key: "kczx3", value: null }
            ],
            yyjz_ghyjcheck: [
                { key: "yyjz_ghyj1", value: null },
                { key: "yyjz_ghyj2", value: null },
                { key: "yyjz_ghyj3", value: null }
            ],
            xmfznycdcheck: [
                { key: "xmfznycd1", value: null },
                { key: "xmfznycd2", value: null },
                { key: "xmfznycd3", value: null }
            ],
            lzwzxcheck: [
                { key: "lzwzx1", value: null },
                { key: "lzwzx2", value: null },
                { key: "lzwzx3", value: null }
            ],
            lzyjxcheck: [
                { key: "lzyjx1", value: null },
                { key: "lzyjx2", value: null },
                { key: "lzyjx3", value: null }
            ],
            ffxjx_xmzxpgcheck: [
                { key: "ffxjx_xmzxpg1", value: null },
                { key: "ffxjx_xmzxpg2", value: null },
                { key: "ffxjx_xmzxpg3", value: null }
            ],
            zxhpggxcheck: [
                { key: "zxhpggx1", value: null },
                { key: "zxhpggx2", value: null },
                { key: "zxhpggx3", value: null }
            ],
            yyjz_xmzxpgcheck: [
                { key: "yyjz_xmzxpg1", value: null },
                { key: "yyjz_xmzxpg2", value: null },
                { key: "yyjz_xmzxpg3", value: null }
            ],
            zf_ghyj: 0,
            zf_xmzxpg: 0,
            zf: 0,
            editData: [],
            editDataLoading: false,
            showghyjl: true,
            showxmzxpgl: true
        };
    },
    computed: {
        visible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadItemData();
                }
            },
            immediate: true
        },
        loading() {
            return this.editDataLoading;
        }
    },
    methods: {
        changeTab(key) {
            this.activeKey = key;
        },
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/listItemZJDFMXOfFH",
                    {
                        cgysbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editData = data.data;
                        // 处理勾选项
                        this.initCheck();
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        //初始化打分项
        //初始化打分项
        initCheck() {
            this.editData.forEach((item) => {
                if (item.djlxid === "GHYJ_FH") {
                    if (item.pdmbbm === "yjnd") {
                        if (item.pdfz >= 13.5 && item.pdfz <= 15.0) {
                            this.yjndcheck[2].value = item.pdfz;
                            this.yjndcheck[1].value = null;
                            this.yjndcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 13.5) {
                            this.yjndcheck[2].value = null;
                            this.yjndcheck[1].value = item.pdfz;
                            this.yjndcheck[0].value = null;
                        } else if (item.pdfz >= 9.0 && item.pdfz < 12.0) {
                            this.yjndcheck[2].value = null;
                            this.yjndcheck[1].value = null;
                            this.yjndcheck[0].value = item.pdfz;
                        } else {
                            this.yjndcheck[0].value = null;
                            this.yjndcheck[1].value = null;
                            this.yjndcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "yjsd") {
                        if (item.pdfz >= 18.0 && item.pdfz <= 20.0) {
                            this.yjsdcheck[2].value = item.pdfz;
                            this.yjsdcheck[1].value = null;
                            this.yjsdcheck[0].value = null;
                        } else if (item.pdfz >= 16.0 && item.pdfz < 18.0) {
                            this.yjsdcheck[2].value = null;
                            this.yjsdcheck[1].value = item.pdfz;
                            this.yjsdcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 16.0) {
                            this.yjsdcheck[2].value = null;
                            this.yjsdcheck[1].value = null;
                            this.yjsdcheck[0].value = item.pdfz;
                        } else {
                            this.yjsdcheck[0].value = null;
                            this.yjsdcheck[1].value = null;
                            this.yjsdcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "cxcd") {
                        if (item.pdfz >= 18.0 && item.pdfz <= 20.0) {
                            this.cxcdcheck[2].value = item.pdfz;
                            this.cxcdcheck[1].value = null;
                            this.cxcdcheck[0].value = null;
                        } else if (item.pdfz >= 16.0 && item.pdfz < 18.0) {
                            this.cxcdcheck[2].value = null;
                            this.cxcdcheck[1].value = item.pdfz;
                            this.cxcdcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 16.0) {
                            this.cxcdcheck[2].value = null;
                            this.cxcdcheck[1].value = null;
                            this.cxcdcheck[0].value = item.pdfz;
                        } else {
                            this.cxcdcheck[0].value = null;
                            this.cxcdcheck[1].value = null;
                            this.cxcdcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "ffxjx_ghyj") {
                        if (item.pdfz >= 13.5 && item.pdfz <= 15.0) {
                            this.ffxjx_ghyjcheck[2].value = item.pdfz;
                            this.ffxjx_ghyjcheck[1].value = null;
                            this.ffxjx_ghyjcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 13.5) {
                            this.ffxjx_ghyjcheck[2].value = null;
                            this.ffxjx_ghyjcheck[1].value = item.pdfz;
                            this.ffxjx_ghyjcheck[0].value = null;
                        } else if (item.pdfz >= 9.0 && item.pdfz < 12.0) {
                            this.ffxjx_ghyjcheck[2].value = null;
                            this.ffxjx_ghyjcheck[1].value = null;
                            this.ffxjx_ghyjcheck[0].value = item.pdfz;
                        } else {
                            this.ffxjx_ghyjcheck[0].value = null;
                            this.ffxjx_ghyjcheck[1].value = null;
                            this.ffxjx_ghyjcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "kczx") {
                        if (item.pdfz >= 13.5 && item.pdfz <= 15.0) {
                            this.kczxcheck[2].value = item.pdfz;
                            this.kczxcheck[1].value = null;
                            this.kczxcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 13.5) {
                            this.kczxcheck[2].value = null;
                            this.kczxcheck[1].value = item.pdfz;
                            this.kczxcheck[0].value = null;
                        } else if (item.pdfz >= 9.0 && item.pdfz < 12.0) {
                            this.kczxcheck[2].value = null;
                            this.kczxcheck[1].value = null;
                            this.kczxcheck[0].value = item.pdfz;
                        } else {
                            this.kczxcheck[2].value = null;
                            this.kczxcheck[1].value = null;
                            this.kczxcheck[0].value = null;
                        }
                    } else if (item.pdmbbm === "yyjz_ghyj") {
                        if (item.pdfz >= 13.5 && item.pdfz <= 15.0) {
                            this.yyjz_ghyjcheck[2].value = item.pdfz;
                            this.yyjz_ghyjcheck[1].value = null;
                            this.yyjz_ghyjcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 13.5) {
                            this.yyjz_ghyjcheck[2].value = null;
                            this.yyjz_ghyjcheck[1].value = item.pdfz;
                            this.yyjz_ghyjcheck[0].value = null;
                        } else if (item.pdfz >= 9.0 && item.pdfz < 12.0) {
                            this.yyjz_ghyjcheck[2].value = null;
                            this.yyjz_ghyjcheck[1].value = null;
                            this.yyjz_ghyjcheck[0].value = item.pdfz;
                        } else {
                            this.yyjz_ghyjcheck[0].value = null;
                            this.yyjz_ghyjcheck[1].value = null;
                            this.yyjz_ghyjcheck[2].value = null;
                        }
                    } else {
                        if (item.pdmbbm === "") {
                            this.zf_ghyj = item.pdfz;
                        }
                    }
                } else if (item.djlxid === "XMZXPG_FH") {
                    if (item.pdmbbm === "xmfznycd") {
                        if (item.pdfz >= 13.5 && item.pdfz <= 15.0) {
                            this.xmfznycdcheck[2].value = item.pdfz;
                            this.xmfznycdcheck[1].value = null;
                            this.xmfznycdcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 13.5) {
                            this.xmfznycdcheck[2].value = null;
                            this.xmfznycdcheck[1].value = item.pdfz;
                            this.xmfznycdcheck[0].value = null;
                        } else if (item.pdfz >= 9.0 && item.pdfz < 12.0) {
                            this.xmfznycdcheck[2].value = null;
                            this.xmfznycdcheck[1].value = null;
                            this.xmfznycdcheck[0].value = item.pdfz;
                        } else {
                            this.xmfznycdcheck[0].value = null;
                            this.xmfznycdcheck[1].value = null;
                            this.xmfznycdcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "lzwzx") {
                        if (item.pdfz >= 18.0 && item.pdfz <= 20.0) {
                            this.lzwzxcheck[2].value = item.pdfz;
                            this.lzwzxcheck[1].value = null;
                            this.lzwzxcheck[0].value = null;
                        } else if (item.pdfz >= 16.0 && item.pdfz < 18.0) {
                            this.lzwzxcheck[2].value = null;
                            this.lzwzxcheck[1].value = item.pdfz;
                            this.lzwzxcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 16.0) {
                            this.lzwzxcheck[2].value = null;
                            this.lzwzxcheck[1].value = null;
                            this.lzwzxcheck[0].value = item.pdfz;
                        } else {
                            this.lzwzxcheck[0].value = null;
                            this.lzwzxcheck[1].value = null;
                            this.lzwzxcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "lzyjx") {
                        if (item.pdfz >= 18.0 && item.pdfz <= 20.0) {
                            this.lzyjxcheck[2].value = item.pdfz;
                            this.lzyjxcheck[1].value = null;
                            this.lzyjxcheck[0].value = null;
                        } else if (item.pdfz >= 16.0 && item.pdfz < 18.0) {
                            this.lzyjxcheck[2].value = null;
                            this.lzyjxcheck[1].value = item.pdfz;
                            this.lzyjxcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 16.0) {
                            this.lzyjxcheck[2].value = null;
                            this.lzyjxcheck[1].value = null;
                            this.lzyjxcheck[0].value = item.pdfz;
                        } else {
                            this.lzyjxcheck[0].value = null;
                            this.lzyjxcheck[1].value = null;
                            this.lzyjxcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "ffxjx_xmzxpg") {
                        if (item.pdfz >= 13.5 && item.pdfz <= 15.0) {
                            this.ffxjx_xmzxpgcheck[2].value = item.pdfz;
                            this.ffxjx_xmzxpgcheck[1].value = null;
                            this.ffxjx_xmzxpgcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 13.5) {
                            this.ffxjx_xmzxpgcheck[2].value = null;
                            this.ffxjx_xmzxpgcheck[1].value = item.pdfz;
                            this.ffxjx_xmzxpgcheck[0].value = null;
                        } else if (item.pdfz >= 9.0 && item.pdfz < 12.0) {
                            this.ffxjx_xmzxpgcheck[2].value = null;
                            this.ffxjx_xmzxpgcheck[1].value = null;
                            this.ffxjx_xmzxpgcheck[0].value = item.pdfz;
                        } else {
                            this.ffxjx_xmzxpgcheck[0].value = null;
                            this.ffxjx_xmzxpgcheck[1].value = null;
                            this.ffxjx_xmzxpgcheck[2].value = null;
                        }
                    } else if (item.pdmbbm === "zxhpggx") {
                        if (item.pdfz >= 18.0 && item.pdfz <= 20.0) {
                            this.zxhpggxcheck[2].value = item.pdfz;
                            this.zxhpggxcheck[1].value = null;
                            this.zxhpggxcheck[0].value = null;
                        } else if (item.pdfz >= 16.0 && item.pdfz < 18.0) {
                            this.zxhpggxcheck[2].value = null;
                            this.zxhpggxcheck[1].value = item.pdfz;
                            this.zxhpggxcheck[0].value = null;
                        } else if (item.pdfz >= 12.0 && item.pdfz < 16.0) {
                            this.zxhpggxcheck[2].value = null;
                            this.zxhpggxcheck[1].value = null;
                            this.zxhpggxcheck[0].value = item.pdfz;
                        } else {
                            this.zxhpggxcheck[2].value = null;
                            this.zxhpggxcheck[1].value = null;
                            this.zxhpggxcheck[0].value = null;
                        }
                    } else if (item.pdmbbm === "yyjz_xmzxpg") {
                        if (item.pdfz >= 9.0 && item.pdfz <= 10.0) {
                            this.yyjz_xmzxpgcheck[2].value = item.pdfz;
                            this.yyjz_xmzxpgcheck[1].value = null;
                            this.yyjz_xmzxpgcheck[0].value = null;
                        } else if (item.pdfz >= 8.0 && item.pdfz < 9.0) {
                            this.yyjz_xmzxpgcheck[2].value = null;
                            this.yyjz_xmzxpgcheck[1].value = item.pdfz;
                            this.yyjz_xmzxpgcheck[0].value = null;
                        } else if (item.pdfz >= 6.0 && item.pdfz < 8.0) {
                            this.yyjz_xmzxpgcheck[2].value = null;
                            this.yyjz_xmzxpgcheck[1].value = null;
                            this.yyjz_xmzxpgcheck[0].value = item.pdfz;
                        } else {
                            this.yyjz_xmzxpgcheck[0].value = null;
                            this.yyjz_xmzxpgcheck[1].value = null;
                            this.yyjz_xmzxpgcheck[2].value = null;
                        }
                    } else {
                        if (item.pdmbbm === "") {
                            this.zf_xmzxpg = item.pdfz;
                        }
                    }
                }
            });
            if (this.zf_xmzxpg > 0) {
                this.activeKey = "2";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.scoreTable {
    width: 90%;
    margin: 0 auto;
    table {
        width: 100%;
        text-align: center;
        tr {
            border: 1px #999 solid;
            td {
                border: 1px #999 solid;
            }
        }
    }
}
</style>
